

/* @ngInject */
function SearchFilters6Controller($scope, $attrs, $stateParams, $location, $timeout, $anchorScroll, $window, $rootScope, raSpinnerService, productLookupService, productFilterService) {
    const vm = this;

    vm.maxFilter = productFilterService.getMaxFilter($scope.currentFilter);
    vm.minFilter = $scope.currentFilter;

    vm.currentFilter = $scope.currentFilter;
    vm.currentFilterTypeId = vm.currentFilter.TypeId;


    // run on init

    function init() {
        // On init, otherwise will set dynamically later when user enters values
        vm.minLimit = null;
        vm.maxLimit = null;
        vm.minValue = null;
        vm.maxValue = null;

        updateFilterFromURL();

        if ($scope.last) {
            $rootScope.$broadcast('searchFiltersDirective.filtersLoaded');
        }
    }
    init();

    (function checkFilterShow() {
        if (typeof vm.currentFilter.InputRangeAttributes === 'undefined' || vm.currentFilter.InputRangeAttributes !== null) {
            vm.currentFilter.showFilter = true;
        } else if (vm.currentFilter.InputRangeAttributes === null) {
            vm.currentFilter.showFilter = false;
        }
    }());

    function updateFilterFromURL() {
        const currentFilter = vm.currentFilter;
        const urlResults = $scope.getFilterURLValues(currentFilter);

        for (let i = 0; i < urlResults.length; i++) {
            if (urlResults[i].searchFilterType === '2') { // min
                const minimum = parseFloat(urlResults[i].values[0]);

                // set service dto
                const filterForMin = productFilterService.getFilterByAttributeNameId(productFilterService.productTypeFilters, currentFilter.Deprecated_ProductAttributeNameId);

                if (filterForMin.InputRangeAttributes) {
                    currentFilter.InputRangeAttributes.minValue = minimum;
                } else {
                    currentFilter.InputRangeAttributes = { minValue: minimum };
                }

                // set vm model
                vm.minValue = currentFilter.InputRangeAttributes.minValue;
            }

            // If max value set
            if (urlResults[i].searchFilterType === '3') { // max
                const maximum = parseFloat(urlResults[i].values[0]);

                // set service dto
                const filterForMax = productFilterService.getFilterByAttributeNameId(productFilterService.productTypeFilters, currentFilter.Deprecated_ProductAttributeNameId);

                if (filterForMax.InputRangeAttributes) {
                    currentFilter.InputRangeAttributes.maxValue = maximum;
                } else {
                    currentFilter.InputRangeAttributes = { maxValue: maximum };
                }

                // set vm model
                vm.maxValue = currentFilter.InputRangeAttributes.maxValue;
            }
        }


        // setup the max filter
        vm.maxFilter.InputRangeAttributes = angular.copy(currentFilter.InputRangeAttributes);
    }

    function updateFilterMinMaxLimits() {
        if (vm.currentFilter.InputRangeAttributes) {
            // Dynamically set min max limits on whats returned from the backend, unless entered value in opposite field is less/greater than that
            vm.minLimit = vm.minValue && (vm.minValue > vm.currentFilter.InputRangeAttributes.Min) ? vm.minValue : vm.currentFilter.InputRangeAttributes.Min;
            vm.maxLimit = vm.maxValue && (vm.maxValue < vm.currentFilter.InputRangeAttributes.Max) ? vm.maxValue : vm.currentFilter.InputRangeAttributes.Max;
        }
    }
    updateFilterMinMaxLimits();

    vm.minMaxChanged = function () {
        for (const filter in productFilterService.productTypeFilters) {
            // Create new values in main DTO for user input values
            if (productFilterService.productTypeFilters[filter].Deprecated_ProductAttributeNameId === vm.currentFilter.Deprecated_ProductAttributeNameId) {
                // setup if not set (for max)
                if (!productFilterService.productTypeFilters[filter].InputRangeAttributes) {
                    productFilterService.productTypeFilters[filter].InputRangeAttributes = { minValue: null, maxValue: null };
                }

                productFilterService.productTypeFilters[filter].InputRangeAttributes.minValue = vm.minValue;
                productFilterService.productTypeFilters[filter].InputRangeAttributes.maxValue = vm.maxValue;
            }
        }

        updateFilterMinMaxLimits();


        $scope.processFilter();

        // check for a few different scenarios for min/max filters on when we should run search
        const minValueAboveLimit = (vm.minLimit <= vm.minValue) && (vm.minValue <= vm.maxLimit);
        const maxValueBelowLimit = (vm.minLimit <= vm.maxValue) && (vm.maxValue <= vm.maxLimit);

        const minValid = vm.minValue ? vm.minValue && minValueAboveLimit : true;
        const maxValid = vm.maxValue ? vm.maxValue && maxValueBelowLimit : true;

        // Make sure min & max values are valid then trigger search
        // if ((min is entered and above limit) OR (max is entered and below limit)
        if ((minValid && maxValid)) {
            // $rootScope.$broadcast('searchFiltersDirective.descriptive-input-changed');
            $scope.processFilter();
        }
    };

    vm.showApply = function () {
        return vm.minValue !== null || vm.minValue !== null || vm.maxValue !== null || vm.maxValue !== null;
    };
}

export default function SearchFilters6Directive() {
    return {
        restrict: 'E',
        templateUrl: 'app/productCenter/pages/productsearch/searchFilters/templates/minmax.html',
        /* @ngInject */
        controller: SearchFilters6Controller,
        controllerAs: 'searchFilter',
    };
}



// WEBPACK FOOTER //
// ./src/app/productCenter/pages/productsearch/searchFilters/directives/searchFilterMinMax.directive.js